module.exports = __webpack_public_path__ + "img/2018_innovation.a1c0aac3.jpg";